import {formatFilterValue} from '../../../Form/actions/filters';
import {Form} from '../../../../stores/Form/Form';
import {priority} from '@priority-software/priority-proto-api/lib';

export const createFiltersFromExposedKeys = (
    keys: Array<{columnName: string; value: string}>,
    form: Form
) => {
    if (keys.length === 0) return null;

    const filters = keys
        .map(key => {
            const column = form.getColumnByName(key.columnName);
            if (!column) return null;

            /*
             * exclude real value from filters. Because it might have formatted value with `parentheses` instead of origin
             * value with `minus` for negative field value
             */
            if (column.Type === priority.netitems.form.ColumnType.Real) {
                return null;
            }
            return new priority.netitems.form.Filter({
                Condition: [
                    new priority.netitems.form.Condition({
                        ColumnID: column?.id,
                        Values: [formatFilterValue(form, column?.id, key.value)]
                    })
                ],
                Operator: priority.netitems.shared.LogicalOperator.Or
            });
        })
        .filter(Boolean);

    return filters.length > 0 ? filters : null;
};
